var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 1)?_c('EmployeeDailyAttendanceTableControl'):(_vm.type === 2)?_c('EmployeeMonthlyAttendanceTableControl'):(_vm.type === 3)?_c('EmployeeYearlyAttendanceTableControl'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }